// Shopify performs the actual localization and currency change. Keep the
// current funnel/query/hash when a visitor explicitly submits its native form.
document.querySelectorAll('[data-market-selector] form').forEach(form => {
  form.addEventListener('submit', () => {
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
  });
});
